module.exports = __webpack_public_path__ + "img/logo.730341a2.svg";